import React, { useEffect } from "react";
import "./MyMarketPopup.css";

const MyMarketPopup = ({
    open,
    onClose,
    rows = [],
    loading = false,
    onSelectMarket,
}) => {
    useEffect(() => {
        if (!open) {
            return undefined;
        }

        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                onClose();
            }
        };

        const previousOverflow =
            document.body.style.overflow;

        document.body.style.overflow = "hidden";

        window.addEventListener(
            "keydown",
            handleKeyDown
        );

        return () => {
            document.body.style.overflow =
                previousOverflow;

            window.removeEventListener(
                "keydown",
                handleKeyDown
            );
        };
    }, [open, onClose]);

    if (!open) {
        return null;
    }

    return (
        <div
            className="my-market-popup-overlay"
            role="presentation"
            onMouseDown={(event) => {
                if (event.target === event.currentTarget) {
                    onClose();
                }
            }}
        >
            <section
                className="my-market-popup"
                role="dialog"
                aria-modal="true"
                aria-labelledby="my-market-popup-title"
            >
                <header className="my-market-popup-header">
                    <h2 id="my-market-popup-title">
                        My Market
                    </h2>

                    <button
                        type="button"
                        className="my-market-popup-close"
                        onClick={onClose}
                        aria-label="Close My Market"
                    >
                        ×
                    </button>
                </header>

                <div className="my-market-popup-content">
                    {loading ? (
                        <div className="my-market-popup-message">
                            Loading markets...
                        </div>
                    ) : rows.length === 0 ? (
                        <div className="my-market-popup-message">
                            No open markets available.
                        </div>
                    ) : (
                        <div className="my-market-table-wrapper">
                            <table className="my-market-table">
                                <thead>
                                    <tr>
                                        <th>Event Type</th>
                                        <th>Event Name</th>
                                        <th>Match Name</th>
                                        <th>Trade</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {rows.map((row) => (
                                        <tr
                                            key={row.id}
                                            onClick={() =>
                                                onSelectMarket?.(row)
                                            }
                                        >
                                            <td>{row.eventType}</td>

                                            <td>
                                                <button
                                                    type="button"
                                                    className="my-market-link"
                                                    onClick={(event) => {
                                                        event.stopPropagation();
                                                        onSelectMarket?.(row);
                                                    }}
                                                >
                                                    {row.eventName}
                                                </button>
                                            </td>

                                            <td>{row.matchName}</td>

                                            <td>{row.tradeCount}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </section>
        </div>
    );
};

export default MyMarketPopup;